import { useEffect, useState } from 'react';

function useTimestamp(timestamp) {
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const date = new Date(timestamp);
    const intervalId = setInterval(() => {
      setMinutes(date.getMinutes());
      setSeconds(date.getSeconds());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [timestamp]);

  return { minutes, seconds };
}

export default useTimestamp;
